import ProTable, { ProColumns } from '@ant-design/pro-table';

import { ExclamationCircleOutlined, UploadOutlined } from '@ant-design/icons';
import {
    Badge,
    Button,
    Checkbox,
    Col,
    Form,
    FormInstance,
    Input,
    message,
    Modal,
    Image,
    Popover,
    Row,
    Space,
    Spin,
    Table,
    TableColumnsType,
    Tooltip,
    Typography,
    Avatar
} from 'antd';
import {
    CheckCircleOutlined,
    CloudDownloadOutlined,
    DownloadOutlined,
    EditOutlined,
    FileImageOutlined,
    PlusOutlined,
    SearchOutlined,
    StopOutlined,
    WarningOutlined
} from '@ant-design/icons';

import { atom, useAtom, useAtomValue } from 'jotai';
import { useContext, useEffect, useState, useRef } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import dayjs from 'dayjs';
import ProCard from '@ant-design/pro-card';

import { Link } from 'react-router-dom';

import { CheckboxValueType } from 'antd/es/checkbox/Group';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpotify, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faB } from '@fortawesome/free-solid-svg-icons';

import { useQuery } from '@tanstack/react-query';
import { atomWithQuery } from 'jotai-tanstack-query';
import axiosApiInstance from '../../api/axiosClient';
import { releasesViewAtom } from '../../CRM/pages/DDEXPage/ddex_atoms';
import DownloadBinariesModal from '../../CRM/pages/DDEXPage/DownloadAllModal';

import { SearchPageContext } from '../SearchPage';
// import { searchCriteriaAtom } from '../SearchForm';
import Search from 'antd/es/transfer/search';
import { queryAtom } from '../SearchForm';

type upcToPlatformMapType = { [k: string]: Array<CheckboxValueType> };
type upcToFormRefMapType = { [k: string]: FormInstance<any> };
type selectedTotalsType = {
    youtube: number;
    believe: number;
    spotify: number;
    total: number;
};

const upcToPlatformMapAtom = atom<upcToPlatformMapType>({});
const upcToFormRefMapAtom = atom<upcToFormRefMapType>({});
const selectedTotalsAtom = atom<selectedTotalsType>({
    youtube: 0,
    believe: 0,
    spotify: 0,
    total: 0
});

const getSelectedUPCs = (upcMap: upcToPlatformMapType) =>
    Object.keys(upcMap).filter((k) => upcMap[k].length > 0);

// const UploadStatusBadgeMap = {
//     uploaded: <Badge text='uploaded' color='green' />,
//     modified: <Badge text='modified' color='blue' />,
//     takedown: <Badge text='takedown' color='red' />
// };

type AlbumCoverProps = {
    upc: string;
    filename: string;
};

export const AlbumCover = ({ upc, filename }: AlbumCoverProps) => {
    // const [imageUrl, setImageUrl] = useState('blank');
    const { data: imageUrl } = useQuery({
      queryKey: ["album_cover", upc, filename],
      queryFn: ({ queryKey }) => {
        return axiosApiInstance
          .post<{ presignedUrl: string }>(
            '/api/digitalassets/generate-archiving-get',
            {
              fileName: filename,
              folderName: upc,
            }
          )
          .then(({ data }) => data.presignedUrl)
          .catch(() => "blank");
      },
    });

    return (
        // <div style={{ boxShadow: '10px 10px #555'}}>
        <Image
            wrapperStyle={{
                boxShadow: '0 0 5px #555'
            }}
            width={80}
            height={80}
            src={imageUrl}
            placeholder
        />
        // </div>
    );
};

// type UploadRowDataType = {
//     key: string;
//     upc: string;
//     title: string;
//     selected: {
//         youtube: boolean;
//         believe: boolean;
//         spotify: boolean;
//     };
// };


const releaseDataAtom = atomWithQuery((get) => {
    const queryString = get(queryAtom);
    return {
        queryKey: ['releases', queryString],
        queryFn: () =>
            axiosApiInstance
                .get<API.MusicDistribution.MusicRelease[]>(`/api/digitalassets/search?${queryString}`)
                .then(({ data }) => data)
    };
});

const DigitalAssetsTable = () => {
    // const [upcToPlatformMap, setUpcToPlatformMap] = useState<upcToPlatformMapType>({});
    const [upcToPlatformMap, setUpcToPlatformMap] = useAtom(upcToPlatformMapAtom);
    const [upcToFormRefMap] = useAtom(upcToFormRefMapAtom);
    const [selectedTotals, setSelectedTotals] = useAtom(selectedTotalsAtom);
    const { releasesActionRef } = useContext(SearchPageContext);
    const [releasesView] = useAtom(releasesViewAtom);
    const [upcToNameMap, setUpcToNameMap] = useState<{ [k: string]: string }>({});
    const [isOpen, setIsOpen] = useState(false);

    // useEffect(() => {
    //     console.log(selectedTotals);
    //     console.log('youtube selected totals === equality ', selectedTotals.youtube === selectedTotals.total);
    //     console.log(
    //         'youtube selected totals double == equality',
    //         selectedTotals.youtube == selectedTotals.total
    //     );
    // }, [selectedTotals]);

    const releases = useAtomValue(releaseDataAtom);
    const navigate = useNavigate();
    const location = useLocation();

    const expandedRowRender = (record: API.MusicDistribution.MusicRelease) => {
        const columns: TableColumnsType<API.MusicDistribution.ArtTrack> = [
            // {title: 'Track #', key: '#', render: (_dom, _entity, index) => <Badge count={index + 1}/>},
            {
                title: 'Vol. #',
                key: 'vol_no',
                render: (_dom, entity) => entity.volume_number
            },
            {
                title: 'Track #',
                key: 'track_no',
                render: (_dom, entity, _index) => entity.track_number
            },
            { title: 'Title', dataIndex: 'title', key: 'title' },
            { title: 'ISRC', dataIndex: 'isrc', key: 'isrc' },
            // {title: 'Duration', dataIndex: 'duration', key: 'duration'},
            {
                title: 'Artist',
                dataIndex: 'track_artist',
                key: 'track_artist',
                render: (_text, { main_artists }) =>
                    // track_artist.names.find(({ is_default }) => is_default).full_name
                    main_artists.map((artist) => artist.key_name).join(', ')
            },
            {
                title: 'Featuring Artists',
                dataIndex: 'featuring_artists',
                key: 'featuring_artists',
                render: (_text, { featuring_artists }) =>
                    featuring_artists.map((artist) => artist.key_name).join(', ')
                // featuring_artists
                //     ?.map(({ names }) => names.find(({ is_default }) => is_default).full_name)
                //     .join(', ')
            },
            {
                title: 'Filename',
                dataIndex: 'filename',
                key: 'filename',
                render: (text) => <i>{text}</i>
            },
            {
                title: '',
                render: (_dom, track) => {
                    return (
                        track.is_uploaded && (
                            <Tooltip title='Download'>
                                <Button
                                    type='link'
                                    icon={<DownloadOutlined />}
                                    onClick={async () => {
                                        try {
                                            const response = await axiosApiInstance.post(
                                                '/api/products/releases/generate-presigned-url-get',
                                                {
                                                    fileName: track.filename,
                                                    folderName: record.upc_ean
                                                }
                                            );

                                            const { presignedUrl } = response.data;

                                            window.open(presignedUrl, '_blank');
                                        } catch (err) {
                                            console.error('Error downloading file:', err);
                                            message.error('Error downloading file');
                                        }
                                    }}
                                />
                            </Tooltip>
                        )
                    );
                }
            }
        ];

        const data = record.art_tracks ?? [];
        return <Table columns={columns} dataSource={data} pagination={false} rowKey={'isrc'} />;
    };

    const filterIcon = (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
    );

    const columns: ProColumns<API.MusicDistribution.MusicRelease>[] = [
        {
            title: '',
            key: 'image',
            search: false,
            render: (_dom, entity) => (
                <AlbumCover upc={entity.upc_ean} filename={entity.album_cover_filename} />
            )
        },
        {
            title: 'Album Name',
            dataIndex: 'name',
            key: 'name',
            filterIcon: filterIcon,
            onFilter: (value, record) => record.name.toLowerCase().includes((value as string).toLowerCase()),
            sorter: (a, b) => a.name.localeCompare(b.name),
            render(_dom, entity, _index, _action, _schema) {
                let name = entity.name;

                if (entity.subtitle != '') {
                    name = `${entity.name} (${entity.subtitle})`;
                }
                return (
                    <Link to={`/DigitalAssets/Search/${entity.upc_ean}/view`} state={{ background: location }}>
                        {name}
                    </Link>
                );
            }
        },
        {
            title: 'UPC',
            dataIndex: 'upc_ean',
            key: 'upc',
            filterIcon: filterIcon,
            onFilter: (value, record) =>
                record.upc_ean.toLowerCase().includes((value as string).toLowerCase())
        },
        {
            title: 'Artist',
            dataIndex: 'main_artist',
            key: 'main_artist',
            renderText: (_text, { artists }) =>
                // main_artist.names.find(({ is_default }) => is_default).full_name
                artists.map((artist) => artist.key_name).join(', ')
        },
        {
            title: 'Label',
            dataIndex: 'label',
            key: 'label',
            renderText: (_text, { label }) => label.name
        },
        {
            title: 'Asset Label',
            dataIndex: 'asset_label',
            key: 'asset_label',
            renderText: (_text, { asset_label }) => asset_label.name
        },
        {
            title: 'Format',
            dataIndex: 'type',
            key: 'type'
        },
        {
            title: 'Release Date',
            dataIndex: 'original_release_date',
            key: 'original_release_date',
            valueType: 'date',
            sorter: (a, b) => dayjs(a.original_release_date).diff(dayjs(b.original_release_date))
        },
        
        // {
        //     title: 'Upload Status',
        //     key: 'upload_status',
        //     hideInTable: releasesView !== 'verified',
        //     children: [
        //         {
        //             title: 'YouTube',
        //             width: 100,
        //             align: 'center',
        //             key: 'youtube_status',
        //             render: (_text, record) => {
        //             const log = record.release_upload_status_logs?.find(
        //                 (log) => log.platform === 'youtube'
        //             );
        //             return log ? (
        //                 <Tooltip title={dayjs(log.created_at).format('YYYY-MM-DD HH:mm')}>
        //                     {UploadStatusBadgeMap[log.status]}
        //                 </Tooltip>
        //                 ) : (
        //                     <Badge status='warning' text={'pending'} />
        //                 );
        //             }
        //         },
        //         {
        //             title: 'Believe',
        //             width: 100,
        //             align: 'center',
        //             key: 'believe_status',
        //             render: (_text, record) => {
        //                 const log = record.release_upload_status_logs?.find(
        //                     (log) => log.platform === 'believe'
        //                 );
        //             return log ? (
        //                 <Tooltip title={dayjs(log.created_at).format('YYYY-MM-DD HH:mm')}>
        //                     {/* <Badge
        //                         status={log.status === 'uploaded' ? 'success' : 'warning'}
        //                         text={log.status}
        //                     /> */}
        //                     {UploadStatusBadgeMap[log.status]}
        //                 </Tooltip>
        //                 ) : (
        //                     <Badge status='warning' text={'pending'} />
        //                 );
        //             }
        //         },
        //         {
        //             title: 'Spotify',
        //             width: 100,
        //             align: 'center',
        //             key: 'spotify_status',
        //             render: (_text, record) => {
        //                 const log = record.release_upload_status_logs?.find(
        //                     (log) => log.platform === 'spotify'
        //                 );
        //                 return log ? (
        //                     <Tooltip title={dayjs(log.created_at).format('YYYY-MM-DD HH:mm')}>
        //                         {/* <Badge
        //                             status={log.status === 'uploaded' ? 'success' : 'warning'}
        //                             text={log.status}
        //                         /> */}
        //                         {UploadStatusBadgeMap[log.status]}
        //                     </Tooltip>
        //                 ) : (
        //                     <Badge status='warning' text={'pending'} />
        //                 );
        //             }
        //         }
        //     ]
        // }
        {
            title: '',
            render: (_dom, record) => {
                return (
                    <>
                        {
                            <Row>
                                <DownloadBinariesModal
                                    onClick={async () => {
                                        const loadingmsg = message.loading(
                                            `Downloading Files from : ${record.name}`, 0
                                        );
                                        const data = await axiosApiInstance
                                        .get(
                                        `/api/products/releases/${record.upc_ean}/binaries`,
                                            {
                                                responseType: "arraybuffer",
                                            }
                                        )
                                        .then(({ data }) => data);
                                        
                                        const url = window.URL.createObjectURL(
                                            new Blob([data])
                                        );
                                        const link = document.createElement("a");
                                        link.href = url;
                                        link.setAttribute(
                                            "download",
                                            `${record.upc_ean}.zip`
                                        );
                                        document.body.appendChild(link);
                                        loadingmsg();
                                        link.click();
                                        message.success(
                                            "Files Downloaded successfully!", 3
                                        );
                                    }}
                                />  
                            </Row>
                        }
                    </>
                );
            }
        }
    ];

    return (
        <ProTable
            dataSource={releases.data}
            loading={releases.isFetching}
            columns={columns}
            params={{
                with_label: '',
                with_artists: '',
                with_track_artists: '',
                is_pending: releasesView === 'pending'
            }}
            type='table'
            toolBarRender={() => [
            ]}
            rowKey={'upc_ean'}
            search={false}
            headerTitle={<ProCard title='Header' />}
            expandable={{ expandedRowRender }}
            actionRef={releasesActionRef}
            // onLoad={(data) => {
            //   const initMap: upcToPlatformMapType = {};
            //   const nameMap: { [k: string]: string } = {};
            //   const records = data.length;
            //   data.forEach((r) => {
            //     initMap[r.upc_ean] = [];
            //     nameMap[r.upc_ean] = r.name;
            //   });
            //   setUpcToPlatformMap(initMap);
            //   setUpcToNameMap(nameMap);
            //   setSelectedTotals((prev) => ({ ...prev, total: records }));
            // }}
            toolbar={{
                menu: {
                    // type: 'tab',
                    activeKey: releasesView,
                    items: [
                        {
                            key: 'verified',
                            label: ''
                        }
                    ]
                }
            }}
        />
    );
};

export default DigitalAssetsTable;